// 1. Função para buscar todos os chamados de uma vez
export async function getAllChamados() {
    try {
        const userSession = JSON.parse(sessionStorage.getItem('user'));

        if (!userSession || !userSession.token) {
            throw new Error("Dados insuficientes no sessionStorage.");
        }

        const { token } = userSession;
        
        // Faz a requisição para a API de chamados para buscar TODOS os chamados
        const response = await fetch(`${process.env.REACT_APP_OPENAI_SERVER_EXPRESS}/chamados/all`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error(`Erro ao buscar chamados: ${response.statusText}`);
        }

        const data = await response.json();
        return data.chamados || []; // Retorna o array de chamados
    } catch (error) {
        console.error("Erro ao buscar chamados:", error);
        return []; // Retorna array vazio em caso de erro
    }
}

// 2. Função que continua buscando chamado individual por ID (mantida para compatibilidade)
export default async function getChamadoByRegistroId(registroId) {
    try {
        const userSession = JSON.parse(sessionStorage.getItem('user'));

        if (!userSession || !userSession.token) {
            throw new Error("Dados insuficientes no sessionStorage.");
        }

        const { token } = userSession;
        
        // Faz a requisição para a API de chamados
        const response = await fetch(`${process.env.REACT_APP_OPENAI_SERVER_EXPRESS}/chamados/${encodeURIComponent(registroId)}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error(`Erro ao buscar chamado: ${response.statusText}`);
        }

        const data = await response.json();

        // Verifica se os dados retornados são válidos
        if (!data || !data.chamado) {
            throw new Error("Resposta inválida da API ou chamado não encontrado.");
        }

        return data; // Retorna os dados do chamado e dos registros
    } catch (error) {
        return { chamado: null, registros: [] }; // Retorna um objeto padrão em caso de erro
    }
}

// 3. Função para processar a relação entre eventos e chamados
export function processEventosEChamados(eventos, chamados) {
    return eventos.map(evento => {
        // Verificar se existe um chamado associado a este evento
        const chamadoAssociado = chamados.find(chamado => chamado.registroId === evento.id);
        
        if (evento.tipo === "Anticarona") {
            return { ...evento, chamado_status: "Ocorrência" };
        }
        
        if (chamadoAssociado) {
            const chamadoStatus = 
                chamadoAssociado.status === "concluído"
                    ? chamadoAssociado.solucao
                        ? "Concluído"
                        : "Concluído/Pendente"
                    : chamadoAssociado.status === "aberto"
                    ? "Pendente"
                    : chamadoAssociado.status === "em andamento"
                    ? "Em andamento"
                    : chamadoAssociado.status;
                    
            return {
                ...evento,
                chamado_status: chamadoStatus,
                chamado_detalhes: chamadoAssociado,
            };
        } else {
            return { ...evento, chamado_status: "Ocorrência" };
        }
    });
}